import React from 'react';
import Security from '../components/dashboard/Security';

const Sicherheit = () => {
  return (
    <>
      <Security />
    </>
  );
};

export default Sicherheit;
